import * as React from 'react'
import type { As, PropsOf, FloraComponent, RightJoinProps } from '@grupoboticario/flora-react-utils'
import type { CSS } from '@grupoboticario/flora'

/**
 * @function
 * @name forwardRef
 * @description Use this function to forwardRef a component and create a `FloraComponent` component
 * @tutorial https://flora.gb.tech/docs/components/core/utils
 */
export const forwardRef = <Component extends As, Props extends object = {}>(
  component: React.ForwardRefRenderFunction<
    any,
    RightJoinProps<PropsOf<Component>, Props> & {
      as?: As
      css?: CSS
    }
  >,
) => {
  return React.forwardRef(component) as unknown as FloraComponent<Component, Props>
}
